"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconContainer = exports.Wrapper = exports.Container = exports.colors = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  z-index: 2000;\n  position: fixed;\n  display: ", ";\n  ", ";\n  @media print {\n    z-index: -2000;\n    display: none !important;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  height: 50px;\n  min-width: 443px;\n  font-family: Sofia Pro;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 16px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.06), 0 2px 10px 0 rgba(0, 0, 0, 0.16);\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    bottom: 30px;\n    right: 30px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    bottom: 30px;\n    left: 30px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    top: 30px;\n    right: 30px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    top: 30px;\n    left: 30px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    background-color: ", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    background-color: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    background-color: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    background-color: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var colors = {
  error: "#FF647C",
  success: "#3FDA98",
  warning: "#FDC300;",
  info: "#35CAE2;"
};
exports.colors = colors;
var types = {
  success: (0, _styledComponents.css)(_templateObject(), colors["success"], colors["success"]),
  warning: (0, _styledComponents.css)(_templateObject2(), colors["warning"], colors["warning"]),
  error: (0, _styledComponents.css)(_templateObject3(), colors["error"], colors["error"]),
  info: (0, _styledComponents.css)(_templateObject4(), colors["info"], colors["info"])
};
var position = {
  topLeft: (0, _styledComponents.css)(_templateObject5()),
  topRight: (0, _styledComponents.css)(_templateObject6()),
  bottomLeft: (0, _styledComponents.css)(_templateObject7()),
  bottomRight: (0, _styledComponents.css)(_templateObject8())
};

var Container = _styledComponents["default"].div(_templateObject9());

exports.Container = Container;

var Wrapper = _styledComponents["default"].div(_templateObject10(), function (props) {
  return props.open ? "flex" : "none";
}, function (props) {
  return props.position && position[props.position];
});

exports.Wrapper = Wrapper;

var IconContainer = _styledComponents["default"].div(_templateObject11(), function (props) {
  return props.success && types["success"];
}, function (props) {
  return props.error && types["error"];
}, function (props) {
  return props.warning && types["warning"];
}, function (props) {
  return props.info && types["info"];
});

exports.IconContainer = IconContainer;